// Launch + waitlist + admin analytics callables (functions/launch, functions/analytics).
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { track, firstTouch } from '../utils/analytics';

const call = async (name, data = {}) => {
  try {
    return (await httpsCallable(getFunctions(getApp()), name)(data)).data;
  } catch (e) {
    const err = new Error(e?.message?.replace(/^(FirebaseError:\s*)?/, '') || 'Something went wrong.');
    err.code = e?.code;
    throw err;
  }
};

/** Join the waitlist. Throws with a readable message on failure (never fakes success). */
export async function joinWaitlist(email, source) {
  const out = await call('joinWaitlist', { email, source, attribution: firstTouch() });
  track('waitlist_join', { source });
  return out;
}

export const getLaunchOverview = () => call('adminLaunchOverview');
export const setLaunch = (cfg) => call('adminSetLaunch', cfg);
export const waitlistAction = (id, action) => call('adminWaitlistAction', { id, action });
export const importLegacyCaptures = () => call('adminWaitlistAction', { action: 'importLegacy' });

export const getAnalyticsOverview = (days = 30) => call('adminAnalyticsOverview', { days });
export const getUsersOverview = () => call('adminUsersOverview');
export const getUserDetail = (uid) => call('adminUserDetail', { uid });
